export type SocialLoginType = {platform: string, data: Record<string, string>|string};

export const SOCIAL_LOGIN_PLATFORMS = {
  GOOGLE: 'google',
};
